/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useAppSelector } from "../../../../../config/hooks";

export interface SummaryRef {
  getHtml: () => string;
  getFullHtml: () => string;
}

interface SummaryProps {
  title?: string;
  content?: string;
  index: number;
  companyLogo?: string;
}
interface PricingItem {
  name: string;
  total_price: number;
  services?: { name: string }[];
}

const SummarySection = forwardRef<SummaryRef, SummaryProps>(
  ({ content = "", index, companyLogo }, ref) => {
    const quillRef = useRef<any>(null);
    const [summaryPageText, setSummaryPageText] = useState<string>(content);
    const pricingData =
      (useAppSelector(
        (state) => state?.potentialDeal?.proposalBuilderData?.data?.pricing
      ) as PricingItem[]) || [];

    console.log("index", index);

    useImperativeHandle(ref, () => ({
      getHtml: () => {
        const value = quillRef.current?.getEditor()?.root.innerHTML || "";
        return `${value}`;
      },
      getFullHtml: () => {
        const value = quillRef.current?.getEditor()?.root.innerHTML || "";
        return `<div class="summary_section">
        <div class="header">
          <div class="proposal_title main_title">
            <div class="page_counter"> 0${index} </div>
            <h4 style="margin-left: 24px;"> Summary </h4>
          </div>
          <div class="logo_container">
          ${
            companyLogo
              ? `<img src="${companyLogo}" class="temp_logo" alt="logo" />`
              : `<img src="/images/company/no_image_grey.png" class="temp_logo" alt="logo"/>`
          }
          </div>
        </div>

        <div class="content">
          ${value}
        </div>
      </div>`;
      },
    }));

    function getPricingHtml(pricing: PricingItem[]): string {
      return pricing
        .map(
          (item) => `
        <div class="pricing_item">
          <p>${item.name}</p>
          ${
            item.services
              ? `<ul>${item.services
                  .map((s) => `<li>${s.name}</li>`)
                  .join("")}</ul>`
              : ""
          }
        </div>`
        )
        .join("");
    }

    useEffect(() => {
      const subtotal = pricingData?.reduce(
        (acc, item) => acc + item?.total_price,
        0
      );
      const coverText = `<p> This proposal outlines our landscaping maintenance services designed to keep your property looking its best throughout the year. Our comprehensive services ensure a well-maintained and attractive outdoor environment. We are committed to providing high-quality, reliable, and professional service tailored to meet your specific needs. 
      <br/><br/> 
      Service is provided weekly except for weather delays, Christmas week and a reduced service visit on Thanksgiving week.<br/><br/>
      <b>Services included</b>
      </p> ${getPricingHtml(pricingData)}<br/>
      <p>Total annual contract cost: <b>$${subtotal.toFixed(2)}</b></p>`;
      setSummaryPageText(coverText);
    }, [pricingData]);

    return (
      <div className="summary_section">
        <div className="header">
          <div className="proposal_title">
            <div className="page_counter"> 0{index} </div>
            <h4 style={{ marginLeft: "24px" }}> Summary </h4>
          </div>
          <div className="logo_container">
            {companyLogo ? (
              <img
                src={companyLogo}
                className="temp_logo"
                alt="template logo"
              />
            ) : (
              <img
                src="/images/company/no_image_grey.png"
                className="temp_logo"
                alt="logo"
              />
            )}
          </div>
        </div>

        <div className="content">
          <ReactQuill
            modules={{
              toolbar: [
                [{ header: [1, 2, false] }],
                ["bold", "italic", "underline", "strike"],
                [{ list: "ordered" }, { list: "bullet" }],
                [{ align: [] }],
                ["link", "image"],
                ["clean"],
              ],
            }}
            formats={[
              "header",
              "bold",
              "italic",
              "underline",
              "strike",
              "list",
              "bullet",
              "align",
              "link",
              "image",
            ]}
            ref={quillRef}
            value={summaryPageText}
            onChange={setSummaryPageText}
          />
        </div>
      </div>
    );
  }
);

export default SummarySection;
